import { useNotify } from '@globaleris/ui.library'
import { Card, makeStyles, useTheme } from '@material-ui/core'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { ProceduresTable } from '../../../../components/shared/proceduresTable/proceduresTable'
import useProcedures from '../../../../components/shared/proceduresTable/proceduresTable.hooks'
import { useConfirmationDialog, useErrorDetailListDialog } from '../../../../hooks'
import { DatePeriod, GlobalNotification } from '../../../../model'
import { styles } from './comunicationProcedures.styles'

export interface ComunicationProceduresPageProps {
  onNotificationChange: (notificacion: GlobalNotification | undefined) => void
  onFetchingChange: (boolean: boolean) => void
  dateRange: DatePeriod
}

export const ComunicationProceduresPage: React.FC<ComunicationProceduresPageProps> = ({
  onNotificationChange,
  onFetchingChange,
  dateRange
}) => {
  const [t] = useTranslation(['globalerisLibrary', 'comunicationProcedures', 'enums'])

  const currentTheme = useTheme()
  const useStyles = makeStyles(styles(currentTheme))
  const classes = useStyles()
  const { info } = useNotify()

  const { showErrorDetailListDialog, errorDetailListDialogProps } = useErrorDetailListDialog()
  const { getConfirmation, closeConfirmation } = useConfirmationDialog()

  const {
    procedures,
    procedure,
    setProcedure,
    isFetchingProcedures,
    isFetchingProcedure,
    refreshProcedures
  } = useProcedures({ datePeriod: dateRange })

  return (
    <Card raised>
      <ProceduresTable
        procedures={procedures}
        procedure={procedure}
        onSelectProcedure={setProcedure}
        onRefreshProcedures={refreshProcedures}
        onNotificationChange={p => {}}
        enableClientLink={true}
      />
    </Card>
  )
}
